var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlignCenter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_403_3166)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 6H23C23.2652 6 23.5196 5.89464 23.7071 5.7071C23.8946 5.51957 24 5.26521 24 5C24 4.73478 23.8946 4.48043 23.7071 4.29289C23.5196 4.10536 23.2652 4 23 4H1C0.734784 4 0.48043 4.10536 0.292893 4.29289C0.105357 4.48043 0 4.73478 0 5C0 5.26521 0.105357 5.51957 0.292893 5.7071C0.48043 5.89464 0.734784 6 1 6Z",
    fill: "#374957"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.99988 9C4.73466 9 4.48031 9.10536 4.29277 9.29289C4.10523 9.48043 3.99988 9.73478 3.99988 10C3.99988 10.2652 4.10523 10.5196 4.29277 10.7071C4.48031 10.8946 4.73466 11 4.99988 11H18.9999C19.2651 11 19.5194 10.8946 19.707 10.7071C19.8945 10.5196 19.9999 10.2652 19.9999 10C19.9999 9.73478 19.8945 9.48043 19.707 9.29289C19.5194 9.10536 19.2651 9 18.9999 9H4.99988Z",
    fill: "#374957"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9999 19H4.99988C4.73466 19 4.48031 19.1054 4.29277 19.2929C4.10523 19.4804 3.99988 19.7348 3.99988 20C3.99988 20.2652 4.10523 20.5196 4.29277 20.7071C4.48031 20.8947 4.73466 21 4.99988 21H18.9999C19.2651 21 19.5194 20.8947 19.707 20.7071C19.8945 20.5196 19.9999 20.2652 19.9999 20C19.9999 19.7348 19.8945 19.4804 19.707 19.2929C19.5194 19.1054 19.2651 19 18.9999 19Z",
    fill: "#374957"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 14H1C0.734784 14 0.48043 14.1054 0.292893 14.2929C0.105357 14.4804 0 14.7348 0 15C0 15.2652 0.105357 15.5196 0.292893 15.7071C0.48043 15.8947 0.734784 16 1 16H23C23.2652 16 23.5196 15.8947 23.7071 15.7071C23.8946 15.5196 24 15.2652 24 15C24 14.7348 23.8946 14.4804 23.7071 14.2929C23.5196 14.1054 23.2652 14 23 14Z",
    fill: "#374957"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_403_3166"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlignCenter);
export default __webpack_public_path__ + "static/media/align-center.aea497a19d011fcd410252cc514720cf.svg";
export { ForwardRef as ReactComponent };